import { useEffect, useMemo, useState } from "react";
import { NewDynamicTab } from "../../../components/Page";
import { PriceForecastDefaultDates } from "../../../config/DefaultDates";
import PriceForcastingIEXDAM from "./PriceForcastingIEXDAM";
import PriceForcastingRTM from "./PriceForcastingRTM";
import { getLatestForecastDate } from "../../../Rest_api/RestApi";
import { ChartAreaLoader } from "../../../components/Loading";

const PriceForecastWrapper = () => {
  const [latestDate, setLatestDate] = useState<Date | null>(null);
  const [isResolvingDate, setIsResolvingDate] = useState(true);

  useEffect(() => {
    const fetchLatestDate = async () => {
      try {
        const response = await getLatestForecastDate({
          product: "DAM",
          exchange: "IEX",
        });

        let dateStr: string | null = null;
        if (typeof response === "string") {
          dateStr = response;
        } else if (response?.date) {
          dateStr = response.date;
        } else if (response?.latest_date) {
          dateStr = response.latest_date;
        }

        if (dateStr) {
          const parsed = new Date(dateStr + "T00:00:00");
          if (!isNaN(parsed.getTime())) {
            setLatestDate(parsed);
          }
        }
      } catch (error) {
        console.error("Error fetching latest forecast date:", error);
      } finally {
        setIsResolvingDate(false);
      }
    };
    fetchLatestDate();
  }, []);

  const defaultDates = useMemo(() => {
    if (!latestDate) return PriceForecastDefaultDates;

    const endDate = latestDate;
    const startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - 15);

    return {
      DAM: {
        type: "range",
        defaultRangeDate: {
          startDate,
          endDate,
          key: "selection",
        },
      },
      RTM: {
        ...PriceForecastDefaultDates["RTM"],
      },
    };
  }, [latestDate]);

  if (isResolvingDate) {
    return <ChartAreaLoader />;
  }

  return (
    <NewDynamicTab
      headerHeight="h-[68px]"
      defaultDates={defaultDates}
      header="Price Forecast"
      tabs={{
        DAM: <PriceForcastingIEXDAM />,
        RTM: <PriceForcastingRTM />,
      }}
      disabledTabs={["RTM"]}
      minDate="2025-03-13"
    />
  );
};

export default PriceForecastWrapper;
